<gallery
  [id]="galleryId()"
  [gallerize]="'gallerize-' + galleryId()"
  [items]="items()"
  [loadingStrategy]="loadingStrategy()"
  [thumb]="showThumbnails()"
  [thumbDetached]="true"
  [counterPosition]="counterPosition()"
  [counter]="false"
  [dots]="false"
  imageSize="contain"
  class="h-full [&_gallery-slider]:bg-grey-900"
  [class.[&_gallery-slider]:mb-md]="showThumbnails()"
  [ngClass]="{
    '[&_gallery-slider]:rounded-t-3 sm:[&_gallery-slider]:rounded-3': flushMobileBottom(),
    '[&_gallery-slider]:rounded-3': !flushMobileBottom(),
  }"
>
  <ng-container *galleryImageDef="let item; let index = index">
    @if ($any(item).title || $any(item).description) {
      <div class="grey-sticker absolute bottom-0 flex w-full flex-col items-start rounded-b-3 p-lg text-white">
        @if ($any(item).title; as title) {
          <div class="heading-base">{{ title }}</div>
        }
        @if ($any(item).description; as description) {
          <div class="image_description mt-2xs text-sm">{{ description }}</div>
        }
      </div>
    }
  </ng-container>
</gallery>
